<template>
  <!-- Cargando: velo + spinner. HTML + CSS plano (sin v-dialog / v-progress-circular). -->
  <div v-if="store.loading" class="ps-loading" role="alert" aria-busy="true" aria-label="Cargando">
    <span class="ps-spinner ps-loading__spinner"></span>
  </div>
</template>

<script setup>
const store = window.useGlobalStore();
</script>

<style scoped>
.ps-loading {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 6000;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(26, 26, 0, 0.25);
}

.ps-loading__spinner {
  width: 56px;
  height: 56px;
  border-width: 5px;
  border-color: rgba(244, 239, 230, 0.35);
  border-top-color: #124b4e;
}
</style>
